import { boxShadow } from '@procurify/ui'
import { em, rem, shade, tint } from 'polished'
import styled from 'styled-components'

interface IChatCommentStyledProps {}

export const ChatCommentStyled = styled.div<IChatCommentStyledProps>`
  font-size: ${rem(16)};

  .comment {
    font-size: ${em(12)};

    padding: 0.75em;

    background: ${(props) => props.theme.colors.white};

    ${boxShadow()};
  }

  .comment-header {
    font-size: 1em;
  }

  .comment-author {
    color: ${(props) => props.theme.colors.primary};
    font-weight: ${(props) => props.theme.fontWeights.bold};
  }

  .comment-date {
    font-size: ${em(10, 12)};
  }

  .comment-header + .comment-date {
    margin-top: 0.25em;

    color: ${(props) => props.theme.colors.darkGrey};
  }

  .mention {
    color: ${(props) => props.theme.colors.text.link};
    background: ${(props) => props.theme.colors.white};
  }
`
